import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import { bannerVideosInitialize, hideVideo } from './banner-videos';

export default function () {

    performance.mark("Swiper module starts")

    const cs = getComputedStyle(document.documentElement);

    //MAIN BANNER
    const mainBanner = new Swiper('.main-banner', {
        modules: [Pagination, Autoplay],
        preloadImages: false,
        lazy: false,
        loop: true,
        autoplay: {
            delay: 7000
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: function (index, className) {
                let pageNumber = index + 1;
                if (pageNumber < 10) pageNumber = `0${index + 1}`;
                return `<span class="${className}">
                            <div class=circle></div>
                            <b class=number>${pageNumber}</b>
                        </span>`;
            },
        },
        on: {
            beforeTransitionStart: function (instance) {

                const currentSlide = instance.slides[instance.activeIndex];
                const slideImg = currentSlide.querySelector('img');

                if (slideImg.hasAttribute('src')) return;

                currentSlide.classList.add('loaded');
                slideImg.setAttribute('src', slideImg.getAttribute('data-src'));
            },
            slideChangeTransitionEnd: function (instance) {

                if (instance.autoplay && !instance.autoplay.running) {
                    instance.autoplay.start();
                }

                const previousSlide = instance.slides[instance.previousIndex];
                if (previousSlide.querySelector("iframe")) {
                    hideVideo(previousSlide);
                }

            }
        }
    });
    bannerVideosInitialize(mainBanner);

    //MAIN PAGE PRODUCTS
    const breakpoints = {
        1: {},
        360: {},
        601: {},
        769: {},
        1280: {}
    };

    const slider2 = new Swiper('.slider-with-products.slider2 .swiper', {
        modules: [Navigation],
        preloadImages: false,
        navigation: {
            nextEl: '.swiper-button-next.slider-button2',
            prevEl: '.swiper-button-prev.slider-button2'
        },
        loop: false,
        breakpoints: breakpoints,
        slidesPerView: Number(cs.getPropertyValue('--prodSwiperCols')),
        spaceBetween: Number(cs.getPropertyValue('--prodGapHor').replace('px', '')),
    });

    slider2.on('breakpoint', function () {
        slider2.params.slidesPerView = Number(cs.getPropertyValue('--prodSwiperCols'));
        slider2.params.spaceBetween = Number(cs.getPropertyValue('--prodGapHor').replace('px', ''));
        slider2.update();
    });

    performance.mark("Swiper module ends")

}